import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-checkbox-cell-editor',
  templateUrl: './checkbox-cell-editor.component.html',
  styleUrls: ['./checkbox-cell-editor.component.css']
})
export class CheckboxCellEditorComponent implements ICellEditorAngularComp {
  params: any;
  options: string[] = []; 
  selectedValues: string[] = []; 

  agInit(params: any): void {
    this.params = params;
    this.options = params.values || [];
    this.selectedValues = params.value ? params.value.split(', ') : []; 
  }

  onCheckboxChange(event: any): void {
    const value = event.target.value;
    if (event.target.checked) {
      this.selectedValues.push(value); 
    } else {
      this.selectedValues = this.selectedValues.filter((v) => v !== value); 
    }
  }

  onSave(): void {
    this.params.stopEditing(this.selectedValues.join(', '));
  }

  onCancel(): void {
    this.params.stopEditing(); 
  }

  getValue(): any {
    return this.selectedValues.join(', '); 
  }

  isPopup(): boolean {
    return true;
  }
}
